import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.string.link.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import { makeStyles, useTheme, useMediaQuery, TextField } from "componentLibrary";
import { IconConstants } from "componentLibrary/MuiComponentWrappers/Icon/IconConstants";
import RaiseButton, { ButtonVariantEnum, ButtonSizeEnum } from "componentLibrary/MuiComponentWrappers/Button/RaiseButton";
import TextLink from "componentLibrary/TextLink/TextLink";
import MuiFormikField from "dashboard/Invoicing/common/MuiFormikField";
import { Form, Formik } from "formik";
import React from "react";
import { Link } from "react-router";
import { WorkplaceOSLoginContainer, useWorkplaceOSLoginStyles, WorkplaceOSLoginHeader, WorkplaceOSLoginLabel, WorkplaceOSLoginError, WorkplaceOSLoginTerms } from "./WorkplaceOSLoginCommon";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      formikContainer: {
        marginBottom: "24px"
      },
      formikButton: {
        borderRadius: "200px",
        height: "48px"
      },
      link: {
        textDecoration: "none",
        marginTop: "24px",
        paddingBottom: "8px"
      },
      additionalButton: {
        marginTop: "16px",
        display: "flex",
        justifyContent: "center",
        width: "100%"
      }
    };
  });
};
var LoginFormContentContainer = function LoginFormContentContainer(_ref) {
  var header = _ref.header,
    subHeader = _ref.subHeader,
    formElements = _ref.formElements,
    ValidationSchema = _ref.ValidationSchema,
    handleSubmit = _ref.handleSubmit,
    loading = _ref.loading,
    isError = _ref.isError,
    errorMessage = _ref.errorMessage,
    buttonText = _ref.buttonText,
    additionalFormLinks = _ref.additionalFormLinks,
    additionalButton = _ref.additionalButton,
    _ref$hidePrimaryButto = _ref.hidePrimaryButton,
    hidePrimaryButton = _ref$hidePrimaryButto === void 0 ? false : _ref$hidePrimaryButto,
    onEmailChange = _ref.onEmailChange;
  var classes = useStyles()();
  var commonClasses = useWorkplaceOSLoginStyles();
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("smMd"));
  var checkForEnter = function checkForEnter(_ref2) {
    var event = _ref2.event,
      submitForm = _ref2.submitForm;
    if (event.keyCode === 13) {
      submitForm();
    }
  };
  var initialValues = _reduceInstanceProperty(formElements).call(formElements, function (obj, element) {
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, element.id, element.initialValue));
  }, {});
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Formik, {
      validationSchema: ValidationSchema,
      initialValues: initialValues,
      onSubmit: handleSubmit,
      validateOnChange: false,
      children: function children(formikUtils) {
        var handleChange = formikUtils.handleChange,
          submitForm = formikUtils.submitForm,
          formErrors = formikUtils.errors;
        var errorCheck = _Object$keys(formErrors).length !== 0 || isError;
        return /*#__PURE__*/_jsx(Form, {
          onKeyDown: function onKeyDown(event) {
            checkForEnter({
              event: event,
              submitForm: submitForm
            });
          },
          children: /*#__PURE__*/_jsxs(WorkplaceOSLoginContainer, {
            children: [/*#__PURE__*/_jsx(WorkplaceOSLoginHeader, {
              title: header || "Sign in",
              subHeader: subHeader
            }), errorCheck && /*#__PURE__*/_jsx(WorkplaceOSLoginError, {
              message: errorMessage
            }), _mapInstanceProperty(formElements).call(formElements, function (element) {
              return /*#__PURE__*/_jsxs("div", {
                className: classes.formikContainer,
                children: [/*#__PURE__*/_jsx(WorkplaceOSLoginLabel, {
                  children: element.label
                }), /*#__PURE__*/_jsx(MuiFormikField, {
                  Component: TextField,
                  fullWidth: true,
                  name: element.id,
                  id: element.id,
                  placeholder: element.placeholder,
                  className: commonClasses.textField,
                  variant: "outlined",
                  size: "large",
                  disabled: element.disabled,
                  InputProps: {
                    classes: {
                      root: commonClasses.textFieldInputRoot
                    }
                  },
                  onChange: function onChange(e) {
                    if (!element.type) {
                      var _context;
                      e.target.value = _trimInstanceProperty(_context = e.target.value).call(_context);
                    }
                    handleChange(e);
                    if (element.id === "usernameLogin" && onEmailChange) {
                      onEmailChange(e.target.value);
                    }
                  },
                  type: element.type
                })]
              }, element.id);
            }), !hidePrimaryButton && /*#__PURE__*/_jsx(RaiseButton, {
              variant: ButtonVariantEnum.primary,
              size: isMobile ? ButtonSizeEnum.medium : ButtonSizeEnum.large,
              onClick: function onClick() {
                submitForm();
              },
              leadingIcon: loading ? IconConstants.SPINNER : undefined,
              disabled: loading,
              children: buttonText
            }), additionalButton && /*#__PURE__*/_jsx("div", {
              className: classes.additionalButton,
              children: additionalButton
            }), additionalFormLinks && _mapInstanceProperty(additionalFormLinks).call(additionalFormLinks, function (link) {
              return /*#__PURE__*/_jsx("div", {
                className: classes.link,
                children: /*#__PURE__*/_jsx(Link, {
                  to: link.to,
                  className: commonClasses.linkText,
                  children: /*#__PURE__*/_jsx(TextLink, {
                    children: link.label
                  })
                })
              }, link.id);
            })]
          })
        });
      }
    }), /*#__PURE__*/_jsx(WorkplaceOSLoginTerms, {})]
  });
};
export default LoginFormContentContainer;